import React, { useState } from "react";

import Page from "../../components/Page";
import VideoViewPageSection from "./VideoViewPageSection";
import Loader from "../../components/Loader/Loader";
import RecommendationDetailPage from "../B2C-Pages/RecommendationDetailPage";

const VideoViewPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <VideoViewPageSection
          isMobile={false}
          isMainPageLoading={isLoading}
          setIsMainPageLoading={setIsLoading}
        />
        <RecommendationDetailPage isMobile={false}/>
      </Page>
    </>
  );
};

export default VideoViewPage;
